/**
 * @generated SignedSource<<440c9290fd1aaf2b05ac3651f25713ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs, Result } from "relay-runtime";
export type Chain = "AVAX" | "BASE" | "BCH" | "BSC" | "BTC" | "DOGE" | "ETH" | "GAIA" | "KUJI" | "LTC" | "NOBLE" | "OSMO" | "SOL" | "TERRA" | "TERRA2" | "THOR" | "TON" | "TRON" | "TRON" | "XRP" | "%future added value";
export type TradeQuery$variables = {
  id: string;
};
export type TradeQuery$data = {
  readonly pair: Result<{
    readonly address?: string;
    readonly assetBase?: {
      readonly chain: Chain;
      readonly metadata: {
        readonly symbol: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"msgAssetFragment">;
    };
    readonly assetQuote?: {
      readonly chain: Chain;
      readonly metadata: {
        readonly symbol: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"msgAssetFragment">;
    };
    readonly book?: {
      readonly " $fragmentSpreads": FragmentRefs<"OrderBookFragment">;
    };
    readonly oracleBase?: {
      readonly id: string;
    } | null | undefined;
    readonly oracleQuote?: {
      readonly id: string;
    } | null | undefined;
    readonly tick?: bigint;
    readonly trades?: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"HistoryFragment">;
      } | null | undefined> | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HeaderTradeFragment" | "SubmitFragment">;
  } | null | undefined, unknown>;
};
export type TradeQuery = {
  response: TradeQuery$data;
  variables: TradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tick",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chain",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Metadata",
    "kind": "LinkedField",
    "name": "metadata",
    "plural": false,
    "selections": [
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "msgAssetFragment"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decimals",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asset",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Denom",
  "kind": "LinkedField",
  "name": "native",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "denom",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetVariants",
  "kind": "LinkedField",
  "name": "variants",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "secured",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        (v4/*: any*/),
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Metadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AssetVariants",
          "kind": "LinkedField",
          "name": "variants",
          "plural": false,
          "selections": [
            (v17/*: any*/)
          ],
          "storageKey": null
        },
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v20 = [
  (v7/*: any*/),
  (v19/*: any*/)
],
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "virtualTotal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "virtualValue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "side",
    "storageKey": null
  }
],
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TradeQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": "pair",
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Asset",
                  "kind": "LinkedField",
                  "name": "assetBase",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Asset",
                  "kind": "LinkedField",
                  "name": "assetQuote",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThorchainOracle",
                  "kind": "LinkedField",
                  "name": "oracleBase",
                  "plural": false,
                  "selections": (v8/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThorchainOracle",
                  "kind": "LinkedField",
                  "name": "oracleQuote",
                  "plural": false,
                  "selections": (v8/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinBook",
                  "kind": "LinkedField",
                  "name": "book",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "OrderBookFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HeaderTradeFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SubmitFragment"
                },
                {
                  "alias": "trades",
                  "args": null,
                  "concreteType": "FinTradeConnection",
                  "kind": "LinkedField",
                  "name": "__HistoryFragment_trades_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FinTradeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "HistoryFragment"
                        },
                        (v9/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FinTrade",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v10/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v11/*: any*/),
                    (v12/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "FinPair",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TradeQuery",
    "selections": [
      {
        "alias": "pair",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "assetBase",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mcap",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "assetQuote",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ThorchainOracle",
                "kind": "LinkedField",
                "name": "oracleBase",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ThorchainOracle",
                "kind": "LinkedField",
                "name": "oracleQuote",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinBook",
                "kind": "LinkedField",
                "name": "book",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinPair",
                    "kind": "LinkedField",
                    "name": "pair",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "assetBase",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v14/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "assetQuote",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "current",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "center",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spread",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinBookEntry",
                    "kind": "LinkedField",
                    "name": "bids",
                    "plural": true,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinBookEntry",
                    "kind": "LinkedField",
                    "name": "asks",
                    "plural": true,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinSummary",
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastUsd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "high",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "low",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "change",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "volumeUsd",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "feeMaker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "feeTaker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deploymentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "FinTradeConnection",
                "kind": "LinkedField",
                "name": "trades",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinTradeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinTrade",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quoteAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseAmount",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": "trades(first:100)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "HistoryFragment_trades",
                "kind": "LinkedHandle",
                "name": "trades"
              }
            ],
            "type": "FinPair",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dea2b9e7e6d66a09120204651150018f",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "pair",
            "trades"
          ]
        }
      ]
    },
    "name": "TradeQuery",
    "operationKind": "query",
    "text": "query TradeQuery(\n  $id: ID!\n) {\n  pair: node(id: $id) {\n    __typename\n    ... on FinPair {\n      address\n      tick\n      assetBase {\n        chain\n        metadata {\n          symbol\n        }\n        ...msgAssetFragment\n        id\n      }\n      assetQuote {\n        chain\n        metadata {\n          symbol\n        }\n        ...msgAssetFragment\n        id\n      }\n      oracleBase {\n        id\n      }\n      oracleQuote {\n        id\n      }\n      book {\n        ...OrderBookFragment\n        id\n      }\n      ...HeaderTradeFragment\n      ...SubmitFragment\n      trades(first: 100) {\n        edges {\n          ...HistoryFragment\n          cursor\n          node {\n            __typename\n            id\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment HeaderTradeFragment on FinPair {\n  id\n  address\n  assetBase {\n    asset\n    type\n    chain\n    metadata {\n      symbol\n      decimals\n    }\n    price {\n      mcap\n      id\n    }\n    id\n  }\n  assetQuote {\n    asset\n    type\n    chain\n    metadata {\n      symbol\n      decimals\n    }\n    id\n  }\n  summary {\n    ...HeaderTradeSummaryFragment\n  }\n}\n\nfragment HeaderTradeSummaryFragment on FinSummary {\n  last\n  lastUsd\n  high\n  low\n  change\n  volumeUsd\n}\n\nfragment HistoryFragment on FinTradeEdge {\n  cursor\n  node {\n    id\n    ...HistoryItemFragment\n  }\n}\n\nfragment HistoryItemFragment on FinTrade {\n  type\n  quoteAmount\n  baseAmount\n  price\n  timestamp\n}\n\nfragment OrderBookEntryFragment on FinBookEntry {\n  price\n  side\n  total\n  value\n  virtualTotal\n  virtualValue\n}\n\nfragment OrderBookFragment on FinBook {\n  id\n  pair {\n    address\n    assetBase {\n      asset\n      metadata {\n        symbol\n        decimals\n      }\n      id\n    }\n    assetQuote {\n      asset\n      metadata {\n        symbol\n        decimals\n      }\n      price {\n        current\n        id\n      }\n      id\n    }\n    tick\n    id\n  }\n  ...OrderBookSubFragment\n}\n\nfragment OrderBookSubFragment on FinBook {\n  id\n  center\n  spread\n  bids {\n    value\n    price\n    total\n    virtualTotal\n    virtualValue\n    ...OrderBookEntryFragment\n  }\n  asks {\n    value\n    price\n    total\n    virtualTotal\n    virtualValue\n    ...OrderBookEntryFragment\n  }\n}\n\nfragment SubmitClassicFragment on FinPair {\n  ...SubmitMarketFragment\n  ...SubmitOracleFragment\n  ...SubmitLimitFragment\n  ...SubmitRecurringFragment\n  address\n  tick\n  assetBase {\n    metadata {\n      symbol\n    }\n    id\n  }\n  assetQuote {\n    metadata {\n      symbol\n    }\n    id\n  }\n  oracleBase {\n    id\n    price\n  }\n  oracleQuote {\n    id\n    price\n  }\n  book {\n    bids {\n      price\n    }\n    center\n    asks {\n      price\n    }\n    id\n  }\n  feeMaker\n  feeTaker\n}\n\nfragment SubmitFragment on FinPair {\n  assetBase {\n    chain\n    asset\n    type\n    metadata {\n      symbol\n      decimals\n    }\n    id\n  }\n  assetQuote {\n    chain\n    asset\n    type\n    metadata {\n      symbol\n      decimals\n    }\n    id\n  }\n  oracleBase {\n    id\n  }\n  oracleQuote {\n    id\n  }\n  ...SubmitClassicFragment\n}\n\nfragment SubmitLimitFragment on FinPair {\n  address\n  tick\n  assetBase {\n    asset\n    type\n    chain\n    metadata {\n      decimals\n      symbol\n    }\n    id\n  }\n  assetQuote {\n    asset\n    type\n    chain\n    metadata {\n      decimals\n      symbol\n    }\n    id\n  }\n  oracleBase {\n    id\n    price\n  }\n  oracleQuote {\n    id\n    price\n  }\n  book {\n    bids {\n      price\n    }\n    center\n    asks {\n      price\n    }\n    id\n  }\n  feeMaker\n  feeTaker\n}\n\nfragment SubmitMarketFragment on FinPair {\n  address\n  tick\n  assetBase {\n    asset\n    type\n    chain\n    metadata {\n      decimals\n      symbol\n    }\n    variants {\n      native {\n        denom\n      }\n    }\n    id\n  }\n  assetQuote {\n    asset\n    type\n    chain\n    metadata {\n      decimals\n      symbol\n    }\n    variants {\n      native {\n        denom\n      }\n    }\n    id\n  }\n  book {\n    bids {\n      total\n      price\n      virtualValue\n      value\n    }\n    center\n    asks {\n      total\n      price\n      virtualValue\n      value\n    }\n    id\n  }\n  feeMaker\n  feeTaker\n  deploymentStatus\n}\n\nfragment SubmitOracleFragment on FinPair {\n  address\n  tick\n  assetBase {\n    asset\n    type\n    chain\n    metadata {\n      decimals\n      symbol\n    }\n    id\n  }\n  assetQuote {\n    asset\n    type\n    chain\n    metadata {\n      decimals\n      symbol\n    }\n    id\n  }\n  oracleBase {\n    id\n    price\n  }\n  oracleQuote {\n    id\n    price\n  }\n  book {\n    bids {\n      price\n    }\n    center\n    asks {\n      price\n    }\n    id\n  }\n  feeMaker\n  feeTaker\n}\n\nfragment SubmitRecurringFragment on FinPair {\n  address\n  tick\n  assetBase {\n    asset\n    metadata {\n      symbol\n      decimals\n    }\n    type\n    chain\n    variants {\n      native {\n        denom\n      }\n      secured {\n        asset\n        type\n        chain\n        metadata {\n          decimals\n          symbol\n        }\n        variants {\n          native {\n            denom\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  assetQuote {\n    asset\n    metadata {\n      symbol\n      decimals\n    }\n    type\n    chain\n    variants {\n      native {\n        denom\n      }\n      secured {\n        asset\n        type\n        chain\n        metadata {\n          decimals\n          symbol\n        }\n        variants {\n          native {\n            denom\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  book {\n    bids {\n      total\n      price\n      value\n    }\n    center\n    asks {\n      total\n      price\n      value\n    }\n    id\n  }\n  feeTaker\n  deploymentStatus\n}\n\nfragment msgAssetFragment on Asset {\n  type\n  chain\n  asset\n  metadata {\n    decimals\n    symbol\n  }\n  variants {\n    native {\n      denom\n    }\n    secured {\n      type\n      chain\n      asset\n      metadata {\n        decimals\n        symbol\n      }\n      variants {\n        native {\n          denom\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18483935b19799e73b31e9b6413b0cb6";

export default node;
